// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@guestsupply/Overrides/Pages/Header";
import { companyLogoItem, xScreen } from "@guestsupply/XDL/Utilities";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.wrapper = {
    css: css`
        z-index: ${getProp("theme.zIndex.header")};
        ${({ isCheckoutPage }: any) => isCheckoutPage && "position: sticky; top: 0;"}
        ${xScreen("lte", "md")} {
            position: sticky;
            top: 0;
            left: 0;
        }
    `,
};
headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    css: css`
        box-shadow: 0 1px 0 0 ${getColor("common.border")};
    `,
};
headerStyles.wrapperPage = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    css: css`
        border-bottom: ${({ isCheckoutPage }: any) => (isCheckoutPage ? "0" : "1px ")} solid
            ${getColor("common.border")};
        ${xScreen("lte", "md")} {
            border: none;
        }
    `,
};
headerStyles.wrapperStyledWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding: ${({ isCheckoutPage }: any) => (isCheckoutPage ? "12px 0" : "15px 0")};
        ${xScreen("lte", "md")} {
            padding: ${({ isCheckoutPage }: any) => (isCheckoutPage ? "13px 0" : "11px 0")};
        }
    `,
};
headerStyles.orderGuideWrapper = {
    css: css`
        flex-grow: 1;
        width: 100%;
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};
headerStyles.searchClickableWrapper = {
    css: css`
        flex-grow: 1;
        width: 100%;
        height: 22px;
        ${xScreen("gt", "sm")} {
            display: none;
        }
    `,
};

headerStyles.signInWrapper = {
    css: css`
        flex-grow: 1;
        width: 100%;
        &.is-chrome {
            position: relative;
            [data-tippy-root] {
                transform: translate(11px, 57px) !important;
                width: 343px;
            }
            &.authenticated {
                [data-tippy-root] {
                    width: 430px;
                }
            }
        }

        ${xScreen("lte", "md")} {
            height: 26px;
        }
    `,
};
headerStyles.cartWrapper = {
    css: css`
        flex-grow: 1;
        width: 100%;
        &.is-chrome {
            position: relative;
            [data-tippy-root] {
                transform: translate(57px, 57px) !important;
                width: 400px;
            }
            &.has-cartlines {
                [data-tippy-root] {
                    width: 603px;
                }
            }
        }

        ${xScreen("lte", "md")} {
            height: 26px;
        }
    `,
};
headerStyles.languageWrapper = {
    css: css`
        flex-grow: 1;
        width: 100%;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
headerStyles.mainNavigationWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
headerStyles.navigationAndLinkedListWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin: 0 -16px;
        width: calc(100% + 32px);
    `,
};

headerStyles.headerLinkListWrapper = {
    css: css`
        .list-wrapper {
            display: flex;
            flex-wrap: nowrap;
        }
    `,
};

headerStyles.searchClickable = {
    clickable: {
        css: css`
            &&& {
                display: none;
                ${xScreen("lte", "sm")} {
                    display: block;
                    margin-left: auto;
                    margin-right: initial;
                }
            }
        `,
    },
};

headerStyles.printLogo = companyLogoItem;

headerStyles.printLogoImage = {
    css: css`
        max-width: 110px;
        max-height: 110px;
    `,
};
